// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    showPlaceholderProductList: true,	
	placeholderProductPerRow: 3,	
    placeholderProductGridItemClass: 'grid__item grid-product small--one-half medium-up--one-third aos-init aos-animate',	    
    refineByStyle: 'style2',
    filterTreeMobileStyle: 'style1',
    requestInstantly: true,
    enableKeepScrollbackPosition: true, // Boost-230379 Scroll to the previous position after going back from Product page
    keepScrollbackPositionType: 'sessionStorage',  // Where to save the scrollback position data: 'sessionStorage' or 'history'
    sessionStorageScrollbackPosition: 'boostPFSScrollbackPostion' // Array - List of scrollback data
  },
};

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;



(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
      var maintitle = data.title.replace(/\s+/g, '');
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap ' +maintitle+'" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';

    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + '" ' +
        'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
        'data-widths="[360, 540, 720, 900, 1080]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }

    // if (!soldOut) {
    //   if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
    //     itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
    //     itemImagesHtml += '<img class="lazyload"' +
    //       'data-src="' + Utils.optimizeImage(images[1].src, '{width}x') + '"' +
    //       'data-widths="[360, 540, 720, 900, 1080]"' +
    //       'data-aspectratio="' + aspectRatio + '"' +
    //       'data-sizes="auto"' +
    //       'alt="{{itemTitle}}">';
    //     itemImagesHtml += '</div>';
    //   }
    // }

// Colleciton image swap code for 4 images starts here (Edit custom code old code just above)

    if (!soldOut) { 
  // We only proceed if hover is enabled AND there is more than one image.
  if (boostPFSConfig.custom.product_hover_image && images.length > 1) { 
    
    // Start the gallery container.
    itemImagesHtml += '<div class="product-image-gallery">'; 

    // Loop through up to 4 images.
    var maxImages = Math.min(images.length, 4);
    for (var i = 0; i < maxImages; i++) {
      var image = images[i];
      // Add 'is-active' class ONLY to the first image (i === 0).
      var isActiveClass = (i === 0) ? ' is-active' : ''; 
      
      // Build the HTML for each image.
      itemImagesHtml += '<img class="product-gallery-image lazyload' + isActiveClass + '"' +
        ' data-src="' + Utils.optimizeImage(image.src, '{width}x') + '"' +
        ' data-widths="[360, 540, 720, 1000]"' +
        ' data-aspectratio="' + (image.aspect_ratio || aspectRatio) + '"' + 
        ' data-sizes="auto"' +
        ' alt="' + (image.alt || '{{itemTitle}}').replace(/"/g, '&quot;') + '">';
    }

    // Close the container.
    itemImagesHtml += '</div>';
  } 
}

// Colleciton image swap code for 4 images ends here


    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    
      // Add wishlist button
        var itemWishlistHtml = "<!-- include 'wishlist-button-collection' with '" + data.id + "' -->";
        itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
      itemPriceHtml += '<span class="save-price">' + boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min))+ '</span>';
    } else {
      itemPriceHtml += '<span class="save-price">' + Utils.formatMoney(data.price_min)+ '</span>';
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = '';
      if (boostPFSConfig.custom.product_save_type == 'dollar') {
        savePrice = '<span class="save-price">' + Utils.formatMoney(data.compare_at_price_min - data.price_min) + '</span>';
      } else {
        savePrice = '<span class="save-price">' + Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min)+ '</span>';
        savePrice += '%';
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    }
    // if(data.tags.includes("no-return") || data.tags.includes("final sale")){
    //         itemPriceHtml += '<span style="font-style: italic;font-size:12px;">&nbsp; Final sale</span>';
    //       }
        var isAccessory = data.tags.some(function(t){ return String(t).toLowerCase() === 'accessories'; });
    if(isAccessory || data.tags.includes("non returnable")){
      itemPriceHtml += '<span style="font-style: italic;font-size:12px;">&nbsp; Non Returnable</span>';
    } else if(data.tags.includes("no-return") || data.tags.includes("final sale")){
      itemPriceHtml += '<span style="font-style: italic;font-size:12px;">&nbsp; Final sale</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });
    var itemLabelHtml = '';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        //itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    
     
    
    // Add Quick shop
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide ' + (isFirstLoad ? '' : 'bc-hide') + '" data-product-id="{{itemId}}">' +
        '<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
        '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var reviewHtml = '';
      if(boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);

    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
          '<div class="modal__centered">' +
            '<div class="modal__centered-content">' +
              '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
            '</div>' +

            '<button type="button" class="modal__close js-modal-close text-link">' +
              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
              '<span class="icon__fallback-text">Close Modal</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);
    
    itemHtml = itemHtml.replace(/{{itemVariantSwatch}}/g, buildSwatchCustom(data));


    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    /* RX collection item data */
    var currentPage = parseInt(Globals.queryParams.page);
    const pageLimit = Globals.queryParams.limit;

    const rxProductDataAttributes = `
      data-item_position="${(currentPage - 1) * pageLimit + index + 1}"
      data-item_id="${data.id}"
      data-item_name="${data.title}"
      data-item_category="${data.product_category}"
      data-price="${data.price_max}"
      onclick="rxTrackProductClick(this)"`

    itemHtml = itemHtml.replace(/{{itemRXData}}/g, rxProductDataAttributes);

    return itemHtml;
  };
  
  function buildSwatchCustom(data) {
    var html = '';

    html += '<div class="variants">';
    for (var i = 0; i < data.variants.length; i++) {
      var variant = data.variants[i];
//       if (variant.available) {
        var displayvariant = variant.title;
      var maintitle = data.title.replace(/\s+/g, '');
    
        var sizevariant = displayvariant.split("/");
        var multivariant = displayvariant.includes("/");
        if (multivariant) {
          if (variant.available) {
            html += '<form method="post" data-cart-submit>';
            html += '<select style="display: none" name="id"><option value="' + variant.id + '"></option></select>';
            if (variant.inventory_quantity <= 0) {
              html += '<input type="hidden" name="properties[Note]" value="Pre-order Item"/>';
              if (data.metafields.length > 0) {
                html += '<input type="hidden" name="properties[Dispatch]" value="' + data.metafields[0].value + '"/>';
              }
              else {
                html += '<input type="hidden" name="properties[Dispatch]" value="15 - 20 Days"/>';
              }
            }
          }
          html += '<button ' + (variant.available ? 'class="boost-add-to-cart" type="submit" name="add"' : ' class="boost-pfs-soldout sold-out"') + (variant.available ? '' : 'disabled') + '">' + sizevariant[1] + '</button>';
          if (variant.available) html += '</form>';
        } else {
          if (variant.available) {
            html += '<form method="post" data-cart-submit>';
            html += '<select style="display: none" name="id"><option value="' + variant.id + '"></option></select>';
            if (variant.inventory_quantity <= 0) {
              html += '<input type="hidden" name="properties[Note]" value="Pre-order Item"/>';
              if (data.metafields.length > 0) {
                html += '<input type="hidden" name="properties[Dispatch]" value="' + data.metafields[0].value + '"/>';
              }
              else {
                html += '<input type="hidden" name="properties[Dispatch]" value="15 - 20 Days"/>';
              }
            }
          }
	      html += '<button ' + (variant.available ? 'class="boost-add-to-cart '+maintitle+'" type="submit" name="add"' : 'class="boost-pfs-soldout sold-out "') + (variant.available ? '' : 'disabled') + '>' + variant.title + '</button>';
          if (variant.available) html += '</form>'; 
        }
//       }
    }
    html += '</div>';

    return html;
  }

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.asset_url.replace('boost-pfs.js', colorValueSlugify + '.png'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';

              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();
    
	jQ(".boost-pfs-soldout").off('click').click(function(e){
        e.preventDefault();
        e.stopPropagation();
        
		toastr['error']('Sorry! Not enough Inventory');
    });
  };

  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    /* RX view collection list event */
    var currentPage = parseInt(Globals.queryParams.page);
    const pageLimit = Globals.queryParams.limit;
    const collectionId = boostPFSAppConfig.general.collection_id;

    const rxProductsData = data.products.map((p, index) => {
      const collectionData = p.collections.find((c) => c.id === collectionId);
      
      return {
          item_id: p.id,
          item_name: p.title,
          affiliation: 'Hemant &amp; Nandita',
          index: (currentPage - 1) * pageLimit + index + 1,
          item_category: p.product_category,
          item_list_id: collectionId,
          item_list_name: collectionData ? collectionData.title : '',
          price: p.price_max,
          quantity: 1
        }
    });

    rxTrackCollectionView(rxProductsData);
    
    jQ('body').addClass('boost-pfs-filter-tree-open-body');

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      toastr.options = {
        "closeButton": false,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
      }
      
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      jQ('.js-drawer-open-collection-filters').on('click', function() {
        jQ('.' + Class.filterOption).each(function() {
          var showMoreType = jQ(this).data('show-more-type');
          if (showMoreType && jQ(this).data('display-type') != 'range') {
            self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
          }
        });
      });
      
      jQ(".shop-add-cart").on('click', function(e){
        e.preventDefault();
        var variant_shop = $(this).data("variant");
        CartJS.addItem(variant_shop); 
      });

      $(document).on('cart.requestComplete', function(event, cart) {
        //var cart = CartJS.getCart();
        var productAdded = cart.items[0]
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: productAdded,
            addToCartBtn: ''
          }
        }));
      });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.collection-filter__item.collection-filter__item--count').html(totalProductText);

    // Build filter button text on mobile
    var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    if (numSelectedFilter) {
      jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    } else {
      jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
      jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    }
    theme.initQuickShop();
  };
  
  /* start-boost-custom */
  /* #boost-101347: Fix filter vanishing on mobile */
  jQ('#FilterDrawer').on('click', function(e) { e.preventDefault(); e.stopPropagation();})
  /* end-boost-custom */
  
    Filter.prototype.afterGetFilterData = function(data, eventType, eventInfo) {
    // Check the case when API returns 0 product on first load
    if (data && Array.isArray(data.products)
        && data.products.length == 0  
        && typeof boostPFSAppConfig.general.collection_product_count != 'undefined'
        && data.products.length != boostPFSAppConfig.general.collection_product_count) {
      // Check if first load
      if (eventType == 'init' && !Settings.general.productAndVariantAvailable
          && !Globals.hasFilterOptionParam
          && typeof FilterApi.beforeCall != 'function'
          && typeof FilterApi.beforeCallAsync != 'function') {

        this.errorFilterCallback();
        return;
      }
    }
    // Pass check, call setData
    this.setData(data, eventType, eventInfo);
  }

  /* Boost-230379 */
  window.addEventListener("pageshow", function(evt) {
        if (evt.persisted && Utils.isiOS()) {
            location.reload();
        }
  }, false);
    /* Boost-230379 */
})();

